<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else-if="!isLoading && $route.name === 'FirmCreate'">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'FirmList' }" class="mb-1 btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.firm.create.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row>
                <b-col>
                  <FirmForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col v-else>
      <FirmForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import FirmForm from './Form'
import Loader from '../../Layout/Loader'
import { ENTRYPOINT } from '@/config/entrypoint'
import { getUserRoles } from '@/utils/checkRoles'
// import getIdFromLink from '@/utils/getIdFromLink'

const { mapGetters, mapActions } = createNamespacedHelpers('userdata/create')

export default {
  components: {
    FirmForm,
    Loader
  },
  props: {
    openedInModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      item: {
        isContractor: 1,
        isCompany: 0,
        isHeadquarters: 0,
        supplier: 0,
        recipient: 0,
        userDataEmployees: [],
        firmname1: '',
        firmname2: '',
        street: '',
        city: '',
        postcode: '',
        province: '',
        userDataTags: [],
        userDataAddresses: [],
        country: 'Polska',
        idRegion: null,
        customSymbol: '',
        idClientType: this.path + 'client_types/7',
        maxOpenCasesForPartnerAllowed: 0
      }
    }
  },

  computed: {
    path () {
      let url = new URL(ENTRYPOINT)
      return url.pathname
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    'item.isCompany': {
      immediate: true,
      handler (val) {
        if (val === 1) {
          if (this.$route.name === 'FirmCreate' && !this.isWholesaler) {
            this.item.idClientType = this.$store.getters['configuration/idClientTypeForContractorsView']
            this.item.isHeadquarters = this.$store.getters['configuration/isHeadquartersForContractorsView']
          } else {
            this.item.idClientType = this.path + 'client_types/6'
          }
        } else {
          this.item.idClientType = this.path + 'client_types/7'
        }
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created || created.isContractor === 0 || this.openedInModal) {
        return
      }

      // this.$router.push({ name: 'FirmUpdate', params: { id: created['@id'] } })
      this.$router.push({ name: 'FirmList' })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = JSON.parse(JSON.stringify(this.item))
      item.userDataTags = item.userDataTags.map(entry => {
        return { '@id': entry['@id'], idTag: entry.value, idUserData: item['@id'], text: entry.text, value: entry.value }
      })
      item.maxOpenCasesForPartnerAllowed = parseInt(item.maxOpenCasesForPartnerAllowed)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
